import * as React from 'react';
export const IcAnxiety = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15 4H9c-3.87 0-7 3.13-7 7 0 3.53 2.61 6.43 6 6.92V20c0 1.24 1.41 1.94 2.4 1.2l4.27-3.2H15c3.87 0 7-3.13 7-7s-3.13-7-7-7zm-7 6c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm6.89 4.74c-.19.17-.43.26-.67.26a.98.98 0 01-.74-.33c-.78-.87-2.18-.87-2.96 0a.997.997 0 11-1.48-1.34C9.8 12.49 10.88 12 12 12c1.12 0 2.2.49 2.96 1.33.37.41.34 1.04-.07 1.41zM15 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
      fill='currentColor'
    />
  </svg>
);
